import { render, staticRenderFns } from "./examMock.vue?vue&type=template&id=b30a089e&scoped=true&"
import script from "./examMock.vue?vue&type=script&lang=js&"
export * from "./examMock.vue?vue&type=script&lang=js&"
import style0 from "./examMock.vue?vue&type=style&index=0&id=b30a089e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30a089e",
  null
  
)

export default component.exports